import React, { useMemo } from "react";
import ReactSelect from "react-select";
import { useSelector, shallowEqual } from "react-redux";

export default function ICustomAddIndustry({ formik }) {
  const industrylist = useSelector(
    ({ categary: { industrylist } }) => industrylist,
    shallowEqual
  );

  const selectedindustries = useMemo(() =>
    Array.isArray(formik.values.industries) ? formik.values.industries : []
    , [formik.values.industries]);

  const industryOptions = useMemo(() =>
    Array.isArray(industrylist) ? industrylist.map(lang => ({ value: lang.id, label: lang.title })) : []
    , [industrylist]);

  const availableOptions = useMemo(() =>
    industryOptions.filter(opt => !selectedindustries.some(s => s.id === opt.value))
    , [industryOptions, selectedindustries]);

  const handleLanguageChange = (selectedOption) => {
    if (!selectedOption) return;
    const newIndustry = {
      id: selectedOption.value,
      title: selectedOption.label,
    };
    formik.setFieldValue("industries", [...selectedindustries, newIndustry]);
  };

  const handleDeleteLanguage = (id) => {
    const updatedIndustry = selectedindustries.filter(
      (language) => language.id !== id,
    );
    formik.setFieldValue("industries", updatedIndustry);
  };

  const validationError = selectedindustries.length < 3 && formik.submitCount > 0;

  return (
    <>
      <div className="form-group">
        <label className="label">Industries</label>
        <div className="skill-sec">
          <div className="add-skills">
            {selectedindustries.map((industry, index) => (
              <div
                key={index}
                onClick={() => {
                  handleDeleteLanguage(industry.id);
                }}
              >
                <p className="indus-p">{industry.title} x</p>
              </div>
            ))}
          </div>
        </div>
        <ReactSelect
          options={availableOptions}
          placeholder="Select industries"
          isClearable={true}
          value={null}
          onChange={(option) => {
            if (option) {
              handleLanguageChange(option);
            }
          }}
        />
      </div>
      {validationError && (
        <p style={{ color: "red" }}>At Least Add 3 industries</p>
      )}
    </>
  );
}
